import { IGameEntry, ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';
import {
  GET_GAMES_SUCCESS,
  GET_GAMES_FAILURE,
  GET_ENTRIES_SUCCESS,
  GET_ENTRIES_FAILURE,
  GET_BONUSES_SUCCESS,
  GET_BONUSES_FAILURE,
  POST_ENTRY_FAILURE,
  PUT_TEAM_MEMBER_SUCCESS,
  PUT_TEAM_MEMBER_FAILURE,
  SET_SELECTED_GAME_ID_SUCCESS,
  SET_PRIZE_SUCCESS,
  SET_PRIZE_FAILURE,
  SET_LOADING_DATA_FOR_GAME,
  SET_REVEAL_ANIMATION_PROGRESS,
  SET_HIDE_PRIZE,
  CLEAR_STATE,
  CLEAR_ERROR,
  SET_LOADING_DATA_FOR_HEADER,
  SET_PAGE_FULLY_LOADED
} from '../types';

import initialState from '../initialState';
import { IInitialState } from 'interfaces/gameInterfaces';

export default (state: IInitialState = initialState, action: any): IInitialState => {
  switch (action.type) {
    case GET_GAMES_SUCCESS:
      return { ...state, games: action.payload.games, currentGameId: action.payload.gameId, selectedGameId: action.payload.gameId };

    case GET_GAMES_FAILURE:
      return { ...state, error: action.error };

    case GET_ENTRIES_SUCCESS:
      const selectedGameEntry = action.entries.find((entry: IGameEntry) => entry.gameId === state.selectedGameId);
      return {
        ...state,
        entries: action.entries,
        selectedEntry: selectedGameEntry,
        loadingDataForGame: action.loadingDataForGame,
        events: action.loadingDataForGame ? state.events : undefined,
        hidePrize: false,
        error: undefined
      };

    case GET_ENTRIES_FAILURE:
      return { ...state, error: action.error, loadingDataForGame: false };

    case GET_BONUSES_SUCCESS:
      return { ...state, bonusCards: action.bonuses };

    case GET_BONUSES_FAILURE:
      return { ...state, error: action.error, bonusCards: undefined };

    case POST_ENTRY_FAILURE:
      return { ...state, error: action.error };

    case PUT_TEAM_MEMBER_SUCCESS:
      if (state.selectedEntry && state.entries) {
        const team: ITeamMember[] = state.selectedEntry.team.map((teamMember: ITeamMember) => {
          if (teamMember.selnNumber !== action.teamMember.selnNumber) {
            return teamMember;
          } else {
            return action.teamMember;
          }
        });

        const newEntry: IGameEntry = {
          currencyCode: state.selectedEntry.currencyCode,
          entryFee: state.selectedEntry.entryFee,
          entryTime: state.selectedEntry.entryTime,
          gameId: state.selectedEntry.gameId,
          gameType: state.selectedEntry.gameType,
          receipt: state.selectedEntry.receipt,
          returns: state.selectedEntry.returns,
          settled: state.selectedEntry.settled,
          status: state.selectedEntry.status,
          team: team,
          totalPoints: state.selectedEntry.totalPoints,
          totalBonusPoints: state.selectedEntry.totalBonusPoints
        };
        const newEntries: IGameEntry[] = state.entries.map((entry: IGameEntry) => {
          if (entry.receipt !== newEntry.receipt) {
            return entry;
          } else {
            return newEntry;
          }
        });
        return { ...state, selectedEntry: newEntry, entries: newEntries, hidePrize: true, error: undefined };
      }
      return { ...state };

    case PUT_TEAM_MEMBER_FAILURE:
      return { ...state, error: action.error };

    case SET_SELECTED_GAME_ID_SUCCESS:
      if (state.entries) {
        return { ...state, selectedGameId: action.selectedGameId, selectedEntry: action.entry, loadingDataForGame: true, error: undefined };
      }
      return { ...state, loadingDataForGame: true };

    case SET_REVEAL_ANIMATION_PROGRESS:
      return { ...state, revealAnimationInProgress: action.complete };

    case SET_PRIZE_SUCCESS:
      return { ...state, prize: action.prize };

    case SET_PRIZE_FAILURE:
      return { ...state, error: action.error };

    case SET_LOADING_DATA_FOR_GAME:
      return { ...state, loadingDataForGame: action.loadingDataForGame };

    case SET_HIDE_PRIZE:
      return { ...state, hidePrize: action.hidePrize };

    case SET_LOADING_DATA_FOR_HEADER:
      return { ...state, loadingDataForHeader: action.loadingDataForHeader };

    case CLEAR_STATE:
      return { ...state, error: undefined, entries: undefined, events: undefined, games: undefined, selectedEntry: undefined, selectedGameId: undefined };

    case CLEAR_ERROR:
      return { ...state, error: undefined };

    case SET_PAGE_FULLY_LOADED:
      return { ...state, pageFullyLoaded: action.pageFullyLoaded };

    default:
      return state;
  }
};
